/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon32Regular = forwardRef('NetConnectRssIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M14.37 7.323a18.5 18.5 0 0 0-7.323-1.317 1 1 0 1 1-.05-2 20.5 20.5 0 0 1 20.997 20.996 1 1 0 0 1-2-.05A18.5 18.5 0 0 0 14.37 7.323Z" }),
        React.createElement("path", { d: "M10.928 15.64a9.5 9.5 0 0 0-3.876-.63 1 1 0 1 1-.094-1.997 11.498 11.498 0 0 1 12.03 12.029 1 1 0 1 1-1.998-.095 9.5 9.5 0 0 0-6.062-9.307Z" }),
        React.createElement("path", { d: "M8 26a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" })));
});
